import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "py-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "max-w-7xl mx-auto 2xl:max-w-screen-2xl" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold text-white capitalize" }, "Thank you for signing up!"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal mt-4 text-white" }, " We’re reviewing your profile. In the meantime please ensure that all the loan criterias look right ")
  ])
], -1)
const _hoisted_2 = { class: "bg-white shadow-sm rounded-md divide-y" }
const _hoisted_3 = { class: "flex justify-between items-center py-4 px-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl leading-8 font-bold text-gray-900" }, "Enchance your profile & sign an NDA", -1)
const _hoisted_5 = { class: "divide-y" }
const _hoisted_6 = { class: "w-1/3 pr-10" }
const _hoisted_7 = { class: "text-lg leading-6 font-medium" }
const _hoisted_8 = { class: "text-sm leading-5 font-normal text-gray-500 mt-1" }
const _hoisted_9 = { class: "w-2/3 pl-10" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-wrap -mb-4"
}
const _hoisted_11 = { class: "text-base leading-6 font-semibold mb-2" }
const _hoisted_12 = { class: "flex items-center h-5" }
const _hoisted_13 = ["id", "name"]
const _hoisted_14 = { class: "ml-3 text-sm" }
const _hoisted_15 = ["for"]
const _hoisted_16 = {
  key: 1,
  class: "flex"
}
const _hoisted_17 = { class: "w-1/2 lg:1/3 pr-2 relative" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "minimumAmount",
  class: "block text-sm font-medium text-gray-700 mb-2"
}, " Minimum amount ", -1)
const _hoisted_19 = { class: "relative w-full" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "$")
], -1)
const _hoisted_21 = { class: "w-1/2 lg:1/3 pr-2 relative" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "maximumAmount",
  class: "block text-sm font-medium text-gray-700 mb-1"
}, " Maximum amount ", -1)
const _hoisted_23 = { class: "relative w-full" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "$")
], -1)
const _hoisted_25 = {
  key: 2,
  class: "flex flex-wrap"
}
const _hoisted_26 = { class: "w-1/2 pr-1" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "block text-sm font-medium text-gray-700"
}, " First name ", -1)
const _hoisted_28 = { class: "mt-2" }
const _hoisted_29 = { class: "w-1/2 pl-1" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "block text-sm font-medium text-gray-700"
}, " Last name ", -1)
const _hoisted_31 = { class: "mt-2" }
const _hoisted_32 = { class: "w-1/2 pr-1 mt-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-gray-700"
}, " Corporate email ", -1)
const _hoisted_34 = { class: "mt-2" }
const _hoisted_35 = { class: "w-1/2 pl-1 mt-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block text-sm font-medium text-gray-700"
}, " Phone ", -1)
const _hoisted_37 = { class: "mt-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "p-6 bg-gray-100 rounded-md" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-base mb-3 font-medium" }, "SPECIAL CONDITIONS:"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-6" }, [
    /*#__PURE__*/_createTextVNode(" 1. The loan assumes no tenant concentrations (student, military, employer, etc)."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 2. The combined net worth among all key principals must be at least equal to the loan amount."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 3. The combined liquidity among all key principals must be at least 9 months of principal and interest payments. For a refinance, it is pre-closing. For a purchase, it is post-closing. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 4. The property may not have a physical occupancy less than 90% for the 90 days preceding the origination date. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 5. Borrowers residing over 100 miles away from \"The Property\" must have a professional 3rd party management company or acceptable property manager in place. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 6. All key principals must have a credit score of at least 680. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-6 mt-3" }, " By signing below borrower hereby acknowledges that from the date hereof Janover Ventures, LLC is the only lender, intermediary or advisor authorized to represent the Borrower and act on behalf of the Borrower with Fannie Mae, Freddie Mac, or the FHA in connection with the proposed financing of the Property as set forth herein. Borrower hereby represents, warrants and covenants that for a period of ninety (90) days from the date of signing this Term Sheet, the Borrower shall be prohibited from seeking Fannie Mae, Freddie Mac, or FHA financing from any other lender or intermediary. Borrower also authorizes Janover Ventures to produce a formal application from Lender. In the event Janover Ventures is unable to produce a formal Application or LOI from lender within 14 business days, Janover Ventures hereby, irrevocably and immediately rescinds aforementioned exclusivity. ")
], -1)
const _hoisted_39 = { class: "mt-3 flex justify-between items-center w-80" }
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = {
  key: 1,
  class: "mt-4 font-bold text-sky"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Vue3Signature = _resolveComponent("Vue3Signature")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "/",
          class: "bg-sky text-white text-sm rounded-md py-2 px-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Save ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, ({ title, subtitle, options }, category) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex p-6",
            key: category
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h4", _hoisted_7, _toDisplayString(title), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(subtitle), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              options
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options, (list, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "w-1/4 mr-10 mb-4",
                        key: key
                      }, [
                        _createElementVNode("h4", _hoisted_11, _toDisplayString(key), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "relative flex items-start mt-1",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("input", {
                                id: category+key+index,
                                "aria-describedby": "comments-description",
                                name: category,
                                type: "checkbox",
                                class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                              }, null, 8, _hoisted_13)
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("label", {
                                for: category+key+index,
                                class: "font-medium text-gray-700 cursor-pointer"
                              }, _toDisplayString(item), 9, _hoisted_15)
                            ])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (category == 'loanAmount')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "border rounded-md h-10 w-full text-sm px-3 pl-6",
                          id: "minimumAmount",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.collectedData.loanAmount.minimumAmount) = $event)),
                          placeholder: ""
                        }, null, 512), [
                          [_vModelText, _ctx.collectedData.loanAmount.minimumAmount]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "border rounded-md h-10 w-full text-sm px-3 pl-6",
                          id: "maximumAmount",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collectedData.loanAmount.maximumAmount) = $event)),
                          placeholder: ""
                        }, null, 512), [
                          [_vModelText, _ctx.collectedData.loanAmount.maximumAmount]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (category == 'contacts')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "firstName",
                          id: "firstName",
                          class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                          placeholder: "David",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collectedData.contacts.firstName) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.collectedData.contacts.firstName]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "lastName",
                          id: "lastName",
                          class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                          placeholder: "Miller",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.collectedData.contacts.lastName) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.collectedData.contacts.lastName]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "email",
                          id: "email",
                          class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                          placeholder: "david.miller@company.com",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.collectedData.contacts.email) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.collectedData.contacts.email]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "phone",
                          id: "phone",
                          class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                          placeholder: "(305) 264-43-33",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.collectedData.contacts.phone) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.collectedData.contacts.phone]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (category == 'nda')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _hoisted_38,
                    (!_ctx.collectedData.nda.signed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_Vue3Signature, {
                            ref_for: true,
                            ref: "signature",
                            sigOption: _ctx.option,
                            w: '320px',
                            h: '200px',
                            class: "border rounded-md overflow-hidden mt-10"
                          }, null, 8, ["sigOption"]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("button", {
                              class: "bg-sky hover:bg-sky-800 text-sm rounded-md text-white px-4 py-2",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.collectedData.nda.signed = true))
                            }, "Sign NDA"),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("button", {
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.undo && _ctx.undo(...args)))
                              }, "Undo"),
                              _createElementVNode("button", {
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args))),
                                class: "ml-2"
                              }, "Clear")
                            ])
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("p", _hoisted_41, "Signed"))
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}